"use client"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { XCircle } from "lucide-react"

interface ImportFailedModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  errors: string[]
  onTryAgain: () => void
}

export function ImportFailedModal({
  open,
  onOpenChange,
  errors,
  onTryAgain,
}: ImportFailedModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[462px]">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold leading-[18px] tracking-[-0.025em]">
            Import failed
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-2 py-4">
          {errors.map((error, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                <XCircle className="h-4 w-4 text-destructive" />
              </div>
              <p className="text-sm text-muted-foreground font-medium leading-5">
                {error}
              </p>
            </div>
          ))}
        </div>

        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onTryAgain}>Try again</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
